import { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  IconX,
  IconChevronLeft,
  IconPhone,
  IconMail,
  IconMapPin,
  IconUserX,
  IconUserMinus,
  IconSparkles,
} from "@tabler/icons-react";
import styles from "./matchDetailModal.module.css";
import CustomModal from "../../Modal/CustomModal";
import { clientMessagesComposeHref } from "../../../utils/functions";

const REMATCH_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

const getInitials = (first, last) => {
  const a = first?.[0] ?? "";
  const b = last?.[0] ?? "";
  return (a + b).toUpperCase() || "?";
};

const MatchDetailModal = ({
  _id,
  job,
  talent,
  navigate,
  handleCancelMatch,
  showModal,
  setShowModal,
  setCancelShowModal,
  matchTimeStamp,
  cancelWindowMs,
  setMatchedTalent,
  setIsCancelMatchBtn,
  setMatchTimeInfo,
  onReportHireLeft,
}) => {
  const isNewMatch = Date.now() - matchTimeStamp <= cancelWindowMs;
  // after the free cancel window, and up to 30 days from the match
  const canReportHireLeft =
    !!matchTimeStamp && !isNewMatch && Date.now() - matchTimeStamp <= REMATCH_WINDOW_MS;

  const handleClose = () => {
    setMatchedTalent(false);
    setIsCancelMatchBtn(false);
    setMatchTimeInfo(null);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={styles.modalBackdrop}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="mdTitle"
    >
      <div className={styles.modalCard}>
        <button
          className={styles.modalClose}
          aria-label="Close"
          onClick={handleClose}
          type="button"
        >
          <IconX size={17} />
        </button>

        <div className={styles.cardTop}>
          {isNewMatch && <span className={styles.newBadge}>New match</span>}
          <div className={styles.avatarLg}>
            {getInitials(talent?.firstName, talent?.lastName)}
          </div>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.row}>
            <span className={styles.avatarSm}>
              {getInitials(talent?.firstName, talent?.lastName)}
            </span>
            <div>
              <div className={styles.name} id="mdTitle">
                {talent?.firstName} {talent?.lastName}
              </div>
              <div className={styles.role}>{job?.title}</div>
              <div className={styles.loc}>
                <IconMapPin size={13} /> {job?.location}
              </div>
            </div>
          </div>

          {isNewMatch && (
            <div className={styles.actions}>
              <button
                className={styles.cancelBtn}
                type="button"
                onClick={() => setCancelShowModal(true)}
              >
                <IconUserX size={15} /> Cancel Match
              </button>
            </div>
          )}

          {canReportHireLeft && onReportHireLeft && (
            <div className={styles.actions}>
              <button
                className={styles.cancelBtn}
                type="button"
                onClick={onReportHireLeft}
              >
                <IconUserMinus size={15} /> Hire Left
              </button>
            </div>
          )}
        </div>

        <div className={styles.modalFoot}>
          <button
            className={styles.backLink}
            type="button"
            onClick={handleClose}
          >
            <IconChevronLeft size={15} /> Back
          </button>
          <div className={styles.footIconBtns}>
            <a
              className={styles.footIconBtn}
              href={`tel:${talent?.phone}`}
              target="_blank"
              rel="noreferrer"
              aria-label="Call"
            >
              <IconPhone size={16} />
            </a>
            <Link
              className={styles.footIconBtn}
              to={clientMessagesComposeHref(talent?.email)}
              aria-label="Message"
            >
              <IconMail size={16} />
            </Link>
          </div>
        </div>
      </div>

      {showModal && (
        <CustomModal
          state="success"
          title="Continue to Talents"
          description="You have successfully unmatched with a talent, Click here to match with another."
          primaryLabel="Talents"
          onClose={() => {
            setShowModal(false);
            navigate("/talent");
          }}
          onPrimaryAction={() => {
            setShowModal(false);
            navigate("/talent");
          }}
        />
      )}
    </div>
  );
};

export default MatchDetailModal;
